// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { Provider } from "react-redux";
// import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
// import { configureStore } from "@reduxjs/toolkit";
// import rootReducer from "./slices";
// import ClickjackProtection from "Clickjackingprotection";

// const root = ReactDOM.createRoot(
//   document.getElementById("root") as HTMLElement
// );
// const store = configureStore({
//   reducer: rootReducer,
//   devTools: true,
// });
// root.render(
//   <React.StrictMode>
//     {/* <ClickjackProtection> */}
//     <Provider store={store}>
//       <BrowserRouter>
//         <App />
//       </BrowserRouter>
//     </Provider>
//     {/* </ClickjackProtection> */}
//   </React.StrictMode>
// );
// //process.env.NODE_ENV === "development"
// // basename={process.env.PUBLIC_URL}
// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();



import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./slices";
import ClickjackProtection from "Clickjackingprotection";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "Common/msal/msalConfig";

// Track page reloads
console.log("🔄 PAGE LOAD/RELOAD DETECTED");
console.log("🔄 Timestamp:", new Date().toISOString());
console.log("🔄 Performance timing:", performance.navigation.type);
if (performance.navigation.type === 1) {
  console.error("⚠️⚠️⚠️ THIS WAS A PAGE RELOAD! ⚠️⚠️⚠️");
}

// Detect navigation
let navigationCount = 0;
window.addEventListener('beforeunload', (e) => {
  console.log("🔄 BEFOREUNLOAD EVENT - Page is about to reload/close");
  console.trace("Stack trace:");
});

window.addEventListener('popstate', (e) => {
  console.log("🔄 POPSTATE EVENT - Browser back/forward");
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});

console.log("🟢 INDEX.TSX - Rendering App");

msalInstance.initialize().then(() => {
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </Provider>
      </MsalProvider>
    </React.StrictMode>
  );
});

reportWebVitals();